import React from 'react';
import { ReactComponent as AlgosIcon } from '../resources/icons/algos.svg';
import { ReactComponent as BacktestIcon } from '../resources/icons/backtest.svg';
import { ReactComponent as HowTosIcon } from '../resources/icons/how-tos.svg';
import { ReactComponent as CalendarTodayIcon } from '../resources/icons/calendar-today.svg';
import { ReactComponent as ScheduleIcon } from '../resources/icons/schedule.svg';
import { ReactComponent as CloseIcon } from '../resources/icons/close.svg';
import { ReactComponent as KeyIcon } from '../resources/icons/key.svg';
import { ReactComponent as KeyNewIcon } from '../resources/icons/key-new.svg';
import { ReactComponent as CopyIcon } from '../resources/icons/copy.svg';
import { ReactComponent as DeleteIcon } from '../resources/icons/delete.svg';
import { ReactComponent as EditIcon } from '../resources/icons/edit.svg';
import { ReactComponent as LinkIcon } from '../resources/icons/link.svg';
import { ReactComponent as InfoIcon } from '../resources/icons/info.svg';
import { ReactComponent as WarningIcon } from '../resources/icons/warning.svg';
import { ReactComponent as WarningOutlineIcon } from '../resources/icons/warning-outline.svg';
import { ReactComponent as SquareOffIcon } from '../resources/icons/squareoff.svg';
import { ReactComponent as SubscriptionOutlineIcon } from '../resources/icons/subscription-outline.svg';
import { ReactComponent as Link2Icon } from '../resources/icons/link-2.svg';
import { ReactComponent as MultiplierOutlineIcon } from '../resources/icons/multiplier-outline.svg';
import { ReactComponent as OrderBookOutlineIcon } from '../resources/icons/order-book-outline.svg';
import { ReactComponent as InstructionsOutlineIcon } from '../resources/icons/instructions-outline.svg';
import { ReactComponent as CampaignOutlineIcon } from '../resources/icons/campaign-outline.svg';

export const Algos = (props) => <AlgosIcon {...props} />;
export const Backtest = (props) => <BacktestIcon {...props} />;
export const HowTos = (props) => <HowTosIcon {...props} />;
export const CalendarToday = (props) => <CalendarTodayIcon {...props} />;
export const Schedule = (props) => <ScheduleIcon {...props} />;
export const Close = (props) => <CloseIcon {...props} />;
export const Key = (props) => <KeyIcon {...props} />;
export const KeyNew = (props) => <KeyNewIcon {...props} />;
export const Copy = (props) => <CopyIcon {...props} />;
export const Delete = (props) => <DeleteIcon {...props} />;
export const Edit = (props) => <EditIcon {...props} />;
export const Link = (props) => <LinkIcon {...props} />;
export const Info = (props) => <InfoIcon {...props} />;
export const Warning = (props) => <WarningIcon {...props} />;
export const WarningOutline = (props) => <WarningOutlineIcon {...props} />;
export const SquareOff = (props) => <SquareOffIcon {...props} />;
export const SubscriptionOutline = (props) => (
  <SubscriptionOutlineIcon {...props} />
);
export const Link2 = (props) => <Link2Icon {...props} />;
export const MultiplierOutline = (props) => (
  <MultiplierOutlineIcon {...props} />
);
export const OrderBookOutline = (props) => <OrderBookOutlineIcon {...props} />;
export const InstructionsOutline = (props) => (
  <InstructionsOutlineIcon {...props} />
);
export const CampaignOutline = (props) => <CampaignOutlineIcon {...props} />;
